import React from "react";

interface SubTitleHeaderProps {
  title: string;
  titleStyle?: string;
  subtitle?: string;
  subtitleStyle?: string;
  notificationStyle?: string;
  childrenTitle?: React.ReactNode;
  children?: React.ReactNode;
  spacer?: boolean;
}

const SubTitleHeader: React.FC<SubTitleHeaderProps> = ({
  titleStyle,
  title,
  subtitle,
  subtitleStyle,
  childrenTitle,
  children,
  spacer,
}) => {
  return (
    <div className="sticky top-0 z-[20] bg-white h-[65px] 2xl:h-[70px]">
      <div
        className={`flex items-center ${
          spacer ? "justify-end" : "justify-between"
        } h-[65px] 2xl:h-[70px]  ${titleStyle}`}
      >
        {childrenTitle}

        <div className="flex items-center space-x-2">{children}</div>
      </div>
      <hr className="ml-[-3rem] mr-[-3rem]" />
    </div>
  );
};

export default SubTitleHeader;
